const $ = jQuery;

$(document).ready(function () {
	const form = document.querySelector("#frm_form_35_container .frm_form_fields .frm_fields_container ");
	if (form) {
		let url = "/wp-admin/admin-ajax.php";
		let reportingPeriodIndex = 0;
		const reportingPeriodField = form.querySelector('[name="item_meta[241]"]');
		const reportingPeriodSelectField = form.querySelector("#frm_field_241_container select");
		$.ajax({
			type: "POST",
			url: url,
			dataType: "json",
			data: {
				action: "ocfp_set_report_quarter",
			},
			success: async function (res) {
				if (res.reportingPeriod) {
					reportingPeriodSelectField.selectedIndex = +res.reportingPeriod;
					const selectedOption = reportingPeriodSelectField.querySelectorAll("option")[+res.reportingPeriod];
					reportingPeriodField.value = selectedOption.value;
					// console.log(selectedOption.value);
				}
				// console.log(res);
			},
		});
	}
});
